export default __webpack_public_path__ + "images/0x0da67235dd5787d67955420c84ca1cecd4e5bb3b.png";